import React, { FC, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { IWallet } from '@sparling/financial-common'
import { Modal } from '../../../../../../../components/Dashboard/Modal'
import { deleteUserWalletRequest } from '../../../../../../../store/actions'

export const RemoveConfirmationModal: FC<{
  wallet: IWallet
  isOpen: boolean
  onClose: () => void
}> = ({ isOpen, onClose, wallet }) => {
  const dispatch = useDispatch()

  const onConfirm = useCallback(() => {
    dispatch(
      deleteUserWalletRequest({
        id: wallet?.id,
      }),
    )
    onClose?.()
  }, [wallet?.id, dispatch, onClose])

  return (
    <Modal isOpen={isOpen} title="Remove Confirmation" modalClose={onClose} onSubmit={onConfirm} isSubmit>
      <p>Are you sure you want to remove {wallet?.currency} wallet?</p>
    </Modal>
  )
}
